import React from 'react';
import { useSelector, useDispatch } from 'react-redux';

import { bindActionCreators } from 'redux';

import * as actionsGroupList from './account.duck';

import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';

import Heading from '../home/components/Heading';
import Footer from '../home/components/Footer';
import ContentSection from '../home/components/ContentSection';

const Main = (props) => {


    const [email, email_set] = React.useState("");
    const [submitted, submitted_set] = React.useState();

    const { account} = useSelector(state => state);
    const actions = bindActionCreators(actionsGroupList, useDispatch());

    const { passwordResetting, passwordResettingSuccess, error } = account;

    return <div>
        <Heading {...props} buttons={[
        ]} />
        <ContentSection>
            {(!passwordResettingSuccess || !submitted) && <div>
                <div>Enter the email address you registered with and a link to reset your account password will be sent to that address.</div>
                <div>Note: If you registered with your Google or Facebook account, you will need to reset your password using their services.</div>
                <div style={{ width: 300 }}>
                    <TextField
                        id="outlined-name"
                        // placeholder="Email"
                        margin="normal"
                        variant="outlined"
                        fullWidth={true}
                        autoComplete="email"
                        type="email"
                        style={{ marginTop: 5 }}
                        value={email}
                        onChange={(event) => {
                            email_set(event.target.value);
                        }}
                        inputProps={{
                            style: {
                                padding: 10,
                            }
                        }}
                        disabled={passwordResetting}
                    />
                </div>
                {error && <div>
                    {error.data}
                </div>}
                <div>
                    <Button variant={'outlined'} color={'primary'} disabled={passwordResetting}
                        onClick={() => {
                            actions.resetPassword({
                                ...props, email, onError: () => {
                                    submitted_set(false);
                                }
                            });
                            submitted_set(true);
                        }}>Submit</Button>
                </div>
            </div>}
            {passwordResettingSuccess && submitted && <div>
                An email has been sent to {email}. Please check your email and follow the provided link to reset your password.
            </div>}
        </ContentSection>
        <Footer />
    </div>
}

export default Main;



// WEBPACK FOOTER //
// ./src/account/ForgotPassword.js